import { useQueryClient } from '@tanstack/react-query';
import { SlidersHorizontal } from 'lucide-react';
import { useClaimModeStore, CLAIM_MODES, CLAIM_MODE_META, type ClaimMode } from '@/store/claim-mode-store.js';

// Global R&D-value lens. Changing it re-sends the X-Claim-Mode header and refetches every query
// so all figures across the app recompute under the chosen method. Locked claims stay frozen.
export function ClaimModeToggle() {
  const rawMode = useClaimModeStore((s) => s.mode);
  const mode: ClaimMode = rawMode in CLAIM_MODE_META ? rawMode : 'business_hours';
  const setMode = useClaimModeStore((s) => s.setMode);
  const queryClient = useQueryClient();

  const onChange = (next: ClaimMode) => {
    if (next === mode) return;
    setMode(next);
    // The header changed; every number view must refetch to reflect the new method.
    void queryClient.invalidateQueries();
  };

  return (
    <div className="flex items-center gap-2">
      <SlidersHorizontal className="h-3.5 w-3.5 text-muted-foreground shrink-0" aria-hidden="true" />
      <label htmlFor="claim-mode" className="text-xs text-muted-foreground whitespace-nowrap">R&D basis</label>
      <select
        id="claim-mode"
        value={mode}
        onChange={(e) => onChange(e.target.value as ClaimMode)}
        title={CLAIM_MODE_META[mode].description}
        className="text-xs rounded-md border bg-background px-2 py-1 max-w-[190px]"
      >
        {CLAIM_MODES.map((m) => (
          <option key={m} value={m} title={CLAIM_MODE_META[m].description}>
            {CLAIM_MODE_META[m].label}
          </option>
        ))}
      </select>
    </div>
  );
}
